export enum TaboolaCategories {
  Advertorial = 'advertorial',
  Voting = 'voting'
}
